import { createSlice } from '@reduxjs/toolkit';

type PostsSliceType = {};

const initialState: PostsSliceType = {};

export const postsSlice = createSlice({
  name: 'posts',
  initialState,
  reducers: {},
});

export const {} = postsSlice.actions;
